import { useQuery } from '@tanstack/react-query';
import { useAuthedFetch, parseJsonOrThrow } from './client';
import { ListAuditResponse } from '../domain';

export interface AuditFilters {
  from?: string;
  to?: string;
  operatorId?: string;
  entity?: string;
  limit?: number;
}

export function useAuditQuery(filters: AuditFilters = {}) {
  const fetcher = useAuthedFetch();
  const params = new URLSearchParams();
  for (const [k, v] of Object.entries(filters)) if (v !== undefined && v !== '') params.set(k, String(v));
  const qs = params.toString();

  return useQuery({
    queryKey: [
      'audit',
      filters.from ?? null,
      filters.to ?? null,
      filters.operatorId ?? null,
      filters.entity ?? null,
      filters.limit ?? null,
    ],
    queryFn: async () => {
      const res = await fetcher(`/audit${qs ? `?${qs}` : ''}`);
      const parsed = await parseJsonOrThrow(res, 'GET /audit', (raw) => ListAuditResponse.parse(raw));
      return parsed.audit;
    },
    refetchInterval: false, // manual refresh only
  });
}
